<section>
  <header>
    Organizer:
    <strong>
      {{ dateService.date | async | moment: "DD.MM.YYYY" }}
    </strong>
  </header>

  <hr />
  <main>
    <ul *ngIf="tasks.length; else noTasks">
      <li class="task" *ngFor="let task of tasks; let i = index">
        <span>
          <strong>{{ i + 1 }}</strong>
          {{ task.title }}
        </span>
        <button class="btn btn-primary" (click)="remove(task)">Remove</button>
      </li>
    </ul>
    <ng-template #noTasks>
      <p class="text-center">No tasks yet...</p>
    </ng-template>
  </main>

  <footer>
    <form (ngSubmit)="submit()" [formGroup]="form">
      <input type="text" formControlName="title" />
      <button
        [disabled]="form.invalid"
        type="submit"
        class="btn btn-primary btn-block"
      >
        Add
      </button>
    </form>
  </footer>
</section>
